import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react"
import { BsThreeDotsVertical } from "react-icons/bs"
import { FiEdit, FiTrash } from "react-icons/fi"

import type { UserPublic } from "../../client"
import useAuth from "../../hooks/useAuth.ts"
import { hasRoleMatch } from "../../utils/roles"
import EditUser from "../Admin/EditUser"
import Delete from "./DeleteAlert"

interface ActionsMenuProps {
  type: "User" // Обмежуємо типи для чіткої типізації
  value: UserPublic
  disabled?: boolean
  isDisabled?: boolean
}

const ActionsMenu = ({ type, value, disabled }: ActionsMenuProps) => {
  const editModal = useDisclosure() // Одне useDisclosure для редагування
  const deleteModal = useDisclosure() // Одне useDisclosure для видалення

  const { user } = useAuth()

  const ownerId =
    "owner_id" in value ? value.owner_id : "ID" in value ? value.ID : null
  // Дозволяємо дію, якщо користувач — власник або має admin/superadmin рівень
  const isAllowed =
    user?.ID === ownerId ||
    hasRoleMatch(user, { level: "superadmin" }, { level: "admin" })

  return (
    <>
      <Menu>
        <MenuButton
          isDisabled={disabled}
          as={Button}
          rightIcon={<BsThreeDotsVertical />}
          variant="unstyled"
        />
        <MenuList>
          <MenuItem
            onClick={editModal.onOpen}
            icon={<FiEdit fontSize="16px" />}
            isDisabled={!isAllowed}
          >
            Edit {type}
          </MenuItem>
          {/* Видалення зміна видалення даних */}
          <MenuItem
            onClick={deleteModal.onOpen}
            icon={<FiTrash fontSize="16px" />}
            color="red.500"
            isDisabled={!isAllowed}
          >
            Delete {type}
          </MenuItem>
        </MenuList>
      </Menu>

      {/* Модальне вікно для редагування */}
      {type === "User" && (
        <EditUser
          user={value as UserPublic}
          isOpen={editModal.isOpen}
          onClose={editModal.onClose}
        />
      )}

      {/* Модальне вікно для видалення */}
      <Delete
        type={type}
        id={"ID" in value && value.ID ? String(value.ID) : ""}
        isOpen={deleteModal.isOpen}
        onClose={deleteModal.onClose}
        isDisabled={!isAllowed}
      />
    </>
  )
}

export default ActionsMenu
